import React from 'react'

export const ThreeDotsIcon: React.FC = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="40" height="40">
    <defs>
      <rect id="three_dots_icon_a" width="40" height="40" x="0" y="0" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="three_dots_icon_b" fill="#fff">
        <use xlinkHref="#three_dots_icon_a" />
      </mask>
      <use fill="#F6F5F4" xlinkHref="#three_dots_icon_a" />
      <path fill="#F6F5F4" d="M0 0h40v40H0z" mask="url(#three_dots_icon_b)" />
      <g mask="url(#three_dots_icon_b)">
        <g transform="translate(8 8)">
          <path d="M0 0h24v24H0z" />
          <circle cx="5" cy="12" r="2" fill="#B3A79D" />
          <circle cx="12" cy="12" r="2" fill="#B3A79D" />
          <circle cx="19" cy="12" r="2" fill="#B3A79D" />
        </g>
      </g>
    </g>
  </svg>
)
